import React from 'react';
import {
  FaCheckCircle,
  FaRegCircle,
  FaSignOutAlt,
  FaTimesCircle,
} from 'react-icons/fa';
import Tooltip from '../tooltip/Tooltip';

export const stayStatusMapping = {
  WAITING_FOR_CONFIRMATION: {
    label: 'Oczekuje na potwierdzenie',
    color: '#971b1b',
    iconColor: '#dc3545',
    bg: '#ffffff',
    borderColor: '#971b1b',
    icon: FaRegCircle,
  },
  NOT_CHECKED_IN: {
    label: 'Nie zameldowano',
    iconColor: '#ffc107',
    color: 'rgb(55, 65, 81)',
    bg: '#ffffff',
    icon: FaRegCircle, // referencja do komponentu, NIE <FaSignInAlt />
    borderColor: 'rgb(55, 65, 81)',
  },
  CHECKED_IN: {
    label: 'Zameldowano',
    color: '#ffffff',
    iconColor: '#198754',
    bg: '#198754',
    icon: FaCheckCircle,
    borderColor: '#ffffff',
  },
  CHECKED_OUT: {
    label: 'Wymeldowano',
    color: '#4f46e5',
    iconColor: '#4f46e5',
    bg: '#ffffff',
    icon: FaSignOutAlt,
    borderColor: '#4f46e5',
  },
  CANCELLED: {
    label: 'Anulowano',
    color: '#971b1b',
    iconColor: '#dc3545',
    bg: '#ffffff',
    borderColor: '#971b1b',
    icon: FaTimesCircle,
  },
};

const StayStatusIcon = ({ reservation }) => {
  const statusInfo = stayStatusMapping[reservation.stayStatus];
  const IconComponent = statusInfo?.icon;

  return (
    <>
      {IconComponent && (
        <Tooltip tooltip={statusInfo.label}>
          <div style={{ color: statusInfo.iconColor }}>
            <IconComponent />
          </div>
        </Tooltip>
      )}
    </>
  );
};

export default StayStatusIcon;
